import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import api from '../utils/api';
import AppLoadingState from './common/AppLoadingState';
import { AppPageShell, PageHeader } from './common/ui';

const DialogFlowChats = () => {
  const [dialogFlows, setdialogFlows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchdialogFlows();
  }, []);

  const fetchdialogFlows = async () => {
    try {
      const response = await api.getdialogFlows();
      console.log('Initial dialogFlows response:', response);
      
      const dialogFlowsWithDetails = await Promise.all(
        response.map(async (dialogFlowInfo) => {
          console.log('Fetching details for dialogFlow:', dialogFlowInfo);
          const detailsResponse = await api.getdialogFlow(dialogFlowInfo.dialogFlow_id || dialogFlowInfo.id);
          return {
            ...detailsResponse,
            id: dialogFlowInfo.dialogFlow_id || dialogFlowInfo.id
          };
        })
      );
      console.log('dialogFlows with details:', dialogFlowsWithDetails);
      setdialogFlows(dialogFlowsWithDetails);
    } catch (error) {
      toast.error('Failed to fetch dialogFlows');
      console.error('Error fetching dialogFlows:', error);
    } finally {
      setLoading(false);
    }
  };

  const handledialogFlowselect = (dialogFlowId) => {
    console.log('Selected dialogFlow:', dialogFlowId);
    navigate(`/app/dialog-flows/${dialogFlowId}/chat`);
  };

  if (loading) {
    return <AppLoadingState layout="section" showLabel={false} />;
  }

  return (
    <AppPageShell maxWidthClass="max-w-6xl">
      <PageHeader
        eyebrow="Conversation design"
        title="Chat with a dialog flow"
        description="Pick a flow to open the sandbox. You will choose a start node, then message the graph like an end user."
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {dialogFlows.map((dialogFlow) => (
          <div
            key={dialogFlow.id}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handledialogFlowselect(dialogFlow.id);
              }
            }}
            onClick={() => handledialogFlowselect(dialogFlow.id)}
            className="cursor-pointer rounded-2xl border border-[var(--app-border)] bg-[var(--app-surface-strong)] p-6 shadow-[var(--app-panel-shadow)] transition duration-200 hover:-translate-y-0.5 hover:border-[var(--app-accent-ring)]"
          >
            <h3 className="font-semibold text-lg text-[var(--app-ink)] mb-2">
              {dialogFlow.name || 'Unnamed dialogFlow'}
            </h3>
            <p className="text-[var(--app-muted)] text-sm line-clamp-2">
              {dialogFlow.description || 'No description available'}
            </p>
            <div className="mt-4 flex items-center text-sm text-[var(--app-muted)]">
              <span>{(dialogFlow.nodes || []).length} nodes</span>
              <span className="mx-2">•</span>
              <span>{(dialogFlow.edges || []).length} connections</span>
            </div>
          </div>
        ))}

        {dialogFlows.length === 0 && (
          <div className="col-span-full rounded-2xl border border-dashed border-[var(--app-empty-border)] bg-[var(--app-empty-bg)] py-12 text-center">
            <p className="text-[var(--app-muted)]">No dialog flows found</p>
            <button
              type="button"
              onClick={() => navigate('/app/dialog-flows')}
              className="mt-4 font-semibold text-[var(--app-accent)] hover:underline"
            >
              Create your first dialog flow
            </button>
          </div>
        )}
      </div>
    </AppPageShell>
  );
};

export default DialogFlowChats; 